

















































import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import { plTextarea } from '@ks/platform-ui';
import { useApolloModel } from 'vue-apollo-model';
import { CurrentUserModel } from '@/models/current-user';
import commentModel from '../commentModel';
import Avatar from '@/components/avatar/index.vue';
import { useBroadcast, useBroadCastStream } from '@/common/utils';

export default defineComponent({
    components: {
        plTextarea,
        Avatar,
    },
    props: {
        isReply: {
            type: Boolean,
        },
        placeholder: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
        },
        maxLength: {
            type: Number,
            default: 40,
        },
        isDark: {
            type: Boolean,
        },
        value: String,
        head: {
            type: Boolean,
            default: true,
        },
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    setup(props, ctx) {
        const user = useApolloModel(CurrentUserModel);
        const comment = useApolloModel(commentModel);
        const isLogin = computed(() => !!user.userInfo.id);

        const focused = ref(false);
        const disableSubmit = ref(true);
        const isActive = ref(false);
        const commentLengthLeft = ref(props.maxLength);
        const broadcast = useBroadcast();
        watch(() => props.value, val => {
            const textLength = val!.length;
            isActive.value = !!(textLength || focused);
            commentLengthLeft.value = props.maxLength - textLength;
            if (!textLength) {
                disableSubmit.value = true;
            } else {
                disableSubmit.value = false;
            }
        });

        watch(focused, val => {
            broadcast('input-focus', val);
        });

        watch(() => props.value, val => {
            broadcast('input-text', val);
        });

        function handleSubmitComment(from: string) {
            // TODO IE 使用enter发送页面会卡死
            // if (from === 'fromEnter') {
            //     return;
            // }

            if (disableSubmit.value) {
                return;
            }
            ctx.emit('submit');
        }

        function handleCancel() {
            if (props.isReply) {
                comment.replyInputId = '';
                broadcast('cancel-reply', {});
            }
            ctx.emit('input', '');
        }

        function handleInput(e: Event) {
            ctx.emit('input', e);
        }

        useBroadCastStream('clean-input', () => {
            handleCancel();
        });

        return {
            user,
            isLogin,
            focused,
            isActive,
            commentLengthLeft,
            disableSubmit,
            handleSubmitComment,
            handleCancel,
            handleInput,
        };
    },
});
